import React, { FC, useEffect, useState } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
import Moment from "moment"
// Components
import ConfirmationModal from "components/modal/confirmation-modal"
// Data
import propertyService from "data/property"
import socketService, * as eventType from "data/socket"
import underwritingService from "data/underwriting"
// Icons
import { DeleteIcon, DownloadIcon} from 'images/icons/tools/'
import { CommercialIcon, FolderIcon, MixedUseIcon, MFRentIcon } from 'images/icons/sidebar/'
// Styles
import { SimpleTable_s } from 'components/dashboard/dashboard-styles'

const UWWidget: FC<RouteComponentProps> = (props) => {
  const [show, setShow]                = useState<boolean>(false)
  const [currentWorkbook, setWorkbook] = useState<object|null>(null)
  const [properties, setProperties]    = useState<object[]|null>(null)
  const [workbooks, setWorkbooks]      = useState<object[]|null>(null)

  useEffect(() => {
    underwritingService.getWorkbooks().then((res)=>{
      setWorkbooks(res)
      getProperties(res)
    })

    const socketSubscription = socketService.stream().subscribe(socket => {
      switch(true) {
        case socket.eventType === eventType.DATA_EXPORT_READY:
          underwritingService.getWorkbooks().then((res)=>{
            setWorkbooks(res)
            getProperties(res)
          })
          break
      }
    })

    return function cleanup() {
      socketSubscription.unsubscribe()
    }
  }, []);

  function getProperties(data:object[]){
    let propertyIds = data.map(workbook => workbook['propertyid'])
    propertyService.fetchProperties(propertyIds).then((properties:any) => {
      setProperties(properties)
    })
  }

  function getScenarioText(workbook){
    return [
      _.get(workbook, 'runtimeparameter.assumptions.scenarioNumber'),
      _.get(workbook, 'runtimeparameter.assumptions.scenarioName')
    ].filter(_.identity).join('-') || 'N/A'
  }

  const toggleShow = () => setShow(!show)

  async function confirm(){
    toggleShow()
    await underwritingService.deleteWorkbook(currentWorkbook!)
    underwritingService.getWorkbooks().then((res)=>{
      setWorkbooks(res)
    })
  }

  const folderIcon      = <Isvg src={FolderIcon} cacheRequests width={18} />;
  const commercialIcon  = <Isvg src={CommercialIcon} cacheGetRequests width={18} />;
  const mfIcon          = <Isvg src={MFRentIcon} cacheGetRequests width={13} />;
  const mixedUseIcon    = <Isvg src={MixedUseIcon} cacheRequests width={20} />;

  const icon = (workbook:object) => {
    let propType = _.find(properties, {propertyid: workbook['propertyid']})?.['type']
    return workbook['context'] === 'folder' ? folderIcon : propType === 'Multifamily' ? mfIcon : propType === 'Mixed-Use' ? mixedUseIcon : commercialIcon
  }                         

  return properties ? <SimpleTable_s>
      <thead>
        <tr>
        <th>Download</th>
        <th>Source</th>
        <th>Path</th>
        <th>Scenario</th>
        <th>Created</th>
        <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        { workbooks && workbooks.map(workbook => {
          return (
            <tr>
              <td className="icon-column">
                <a onClick={()=>underwritingService.getWorkbook(workbook)}>
                  <Isvg src={DownloadIcon} cacheGetRequests width={18} />
                </a>
              </td>
              <td className="icon-column">{icon(workbook)}</td>
              <td>{workbook['exportpath']}</td>
              <td>{getScenarioText(workbook)}</td>
              <td className="created-column">{Moment.tz(Moment.utc(workbook['requestcomplete']), Moment.tz.guess()).format('MM/DD/YYYY h:mm A')}</td>
              <td className="icon-column">
                <a><Isvg src={DeleteIcon} onClick={()=>{setShow(true); setWorkbook(workbook)}} cacheGetRequests width={18} /></a>
              </td>
            </tr>
          )
        })}
      </tbody>
      <ConfirmationModal
        height={100}
        width={600}
        contentHeight={50}
        show={show}
        toggleShow={toggleShow}
        title={"Delete Confirmation"}
        confirmText={"Delete"}
        message={""}
        confirmFunc={confirm}
        cancelFunc={toggleShow}
        confirmOnly={false}
        closeOnly={false}>
        {`Are you sure that you want to delete the underwriting workbook ${currentWorkbook?.['filename']}?`}
      </ConfirmationModal>
    </SimpleTable_s> : null
}

export default UWWidget
